<div class="p-field" *ngIf="formControl">
  <label for="wardGeoId">{{ 'Xã/phường'|translate }}<span class="required" *ngIf="required">*</span></label>
  <p-dropdown id="wardGeoId" [options]="counties" [filter]="true" [formControl]="formControl"
              [showClear]="true" appendTo="body" placeholder="-" (ngModelChange)="ngModelChange()"></p-dropdown>
</div>
